module.exports = __webpack_public_path__ + "static/img/bg.3135b50.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/fiveG/bg.png
// module id = 9+qY
// module chunks = 1